import React from 'react'
import { RowDetail } from './RowDetail.jsx'

import * as css from '../../asignacion-fondos/Fondos.css'

let PropTypes = React.PropTypes

export class TableDetails extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        let totalGastos = this.props.gastos.length
        return (
            <div className={"panel panel-default "+css.panelInventarios}>
                <div className={"panel-heading "+css.panelHeadingDetalle}><b>Listado de gastos</b></div>
                <div className={"panel-body "+css.panelBodyCustom}>
                    <TablaRendiciones>
                        {_.range(0, totalGastos).map(index=>{
                            let gasto = this.props.gastos[index]
                            return <RowDetail
                                key={index}
                                index={index}
                                gasto={gasto}
                            />
                        })}
                    </TablaRendiciones>
                </div>
            </div>
        )
    }
}
let TablaRendiciones = ({children}) =>
    <table className={"table table-condensed "+css.tableFixed+" "+css.panelDetalleInventarios}>
        <colgroup>
            <col className={css.colIndex}/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col className={css.colFoto}/>
            <col className={css.colFoto}/>
        </colgroup>
        <thead>
        <tr>
            <th className="thIndex">#</th>
            <th></th>
            <th>Fecha</th>
            <th>Total</th>
            <th>Documento</th>
            <th>Clasificación</th>
            <th>Glosa</th>
            <th>Foto</th>
            <th className={css.thFoto}></th>
            <th className={css.thFoto}></th>
            
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/detalle-rendicion/TableDetails.jsx